import request from "@/utils/request";

export default function save(params) {
    return request({
        url: `/storeShop/agency/save`,
        method: 'post',
        data:params
    })
}
